import { toast } from 'sonner';
import { DialogEnum, useActionDialogContext } from './Context/ActionDialogContext';
import { useCandidatesClient } from '@/Hooks/ClientHooks';
import DefaultAssessmentResetDialog from '@/Pages/Candidates/components/dialogs/AssessmentResetDialog/AssessmentResetDialog';
import UIStrings from '@/Utils/UIStrings';

interface TableAssessmentResetDialogProps {
    onAssessmentReset?: () => void;
}

const TableAssessmentResetDialog = ({ onAssessmentReset }: TableAssessmentResetDialogProps) => {
    const candidatesClient = useCandidatesClient();
    const { isDialogOpen, hideDialog, selectedCandidates } = useActionDialogContext();

    const handleConfirm = async () => {
        if (selectedCandidates[0]) {
            const { assessmentId, candidateId, candidateFirstName } = selectedCandidates[0];
            try {
                await candidatesClient.resetApplicantAssessmentResultAsync(assessmentId, candidateId);
                toast.success(UIStrings.successAssessmentResetToast(candidateFirstName));
                onAssessmentReset?.();
            } catch {
                toast.error(UIStrings.errorAssessmentResetToast(candidateFirstName));
            }
        }
    };

    return (
        <DefaultAssessmentResetDialog
            open={isDialogOpen(DialogEnum.ResetAssessment)}
            setOpen={() => hideDialog(DialogEnum.ResetAssessment)}
            onConfirm={handleConfirm}
        />
    );
};

export default TableAssessmentResetDialog;
